import React from "react";
import { ReactComponent as GroupIcon } from "../../assets/icons/group-icon.svg";
import { ReactComponent as XClose } from "../../assets/icons/x-close.svg";
import { useDispatch } from "react-redux";
import {
  modalViewsConst,
  setModalOpen,
  setModalState,
} from "../../store/modalSlice";

export const AddGroupFirst = () => {
  const dispatch = useDispatch();
  const handleConfirm = () => {
    dispatch(
      setModalState({
        modalOpen: true,
        modalView: modalViewsConst.addAssetGroup,
        properties: null,
      })
    );
  };

  return (
    <div className="">
      <div className="flex flow-row grow items-center border-b border-eai-border p-5">
        <div className="eai-card flex flex-0 w-10 h-10 mr-3 items-center justify-center">
          <GroupIcon className="h-6 w-6" />
        </div>
        <div className="flex grow mr-3 justify-end"></div>
        <button
          type="button"
          onClick={() => dispatch(setModalOpen(false))}
          aria-label="Close"
          className="shrink-0 flex w-10 h-10 items-center justify-center rounded-full text-eai-ink-subtle transition-colors hover:bg-eai-surface-hover hover:text-eai-ink active:bg-eai-surface-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-eai-focus-neutral focus-visible:ring-offset-1"
        >
          <XClose className="h-6 w-6 [&_path]:stroke-current" />
        </button>
      </div>

      <div className="h-1 flex grow"></div>
      <div className="flex grow justify-center items-center">
        <div className="eai-card flex flex-0 w-14 h-14 items-center mt-8 justify-center">
          <GroupIcon className="h-6 w-6" />
        </div>
      </div>
      <div className="flex flex-col grow p-5 items-center justify-center">
        <div className="eai-h3-title mb-2">
          Add a Group First
        </div>
        <div className="eai-description">
          You need to create a group before you can add a new asset
        </div>
      </div>
      <div className="flex flex-row grow space-x-3 p-5">
        <button
          className="eai-btn-outline flex-grow my-1"
          onClick={() => dispatch(setModalOpen(false))}
        >
          <div className="mx-3">Cancel</div>
        </button>
        <button className="eai-btn-cta flex-grow my-1" onClick={handleConfirm}>
          <div className="mx-3">Okay</div>
        </button>
      </div>
    </div>
  );
};
